<template>
  <div class="section-form">
    <v-layout row wrap>
      <v-flex
        v-if="loan.loanType === assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && layoutSetting.section.name === 'payment-option'"
        class="p-v-0 lg12"
        :key="assist.tool.getRandomKey (100)"
      >
        <div style="margin: 10px"></div>
      </v-flex>
      <template
        v-for="(field, index) in (loan.loanType === assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && layoutSetting.section.name === 'payment-option' ? layoutSetting.multipleLoanSectionFields : layoutSetting.sectionFields)"
      >
        <v-flex v-if="field.blankRow" class="p-v-0 lg12" :key="assist.tool.getRandomKey (index)">
          <div style="margin: 10px"></div>
        </v-flex>
        <v-flex
          class="p-v-0"
          :class="field.labelClass ? field.labelClass : 'lg3'"
          :key="assist.tool.getRandomKey (index)"
          v-if="isDisplayField(field.fieldKey, field.loanType) && !field.blankRow && !field.divider"
        >
          <label class="field-name">
            <arb-review-status-icon
              v-if="field.isVerify && assist.tool.isEmpty(field.verifyPosition)"
              :keys="field.fieldKey"
              :reviewData="reviewData"
            ></arb-review-status-icon>
            {{ field.label }}
            <arb-review-status-icon
              v-if="field.isVerify && field.verifyPosition === 'right'"
              :keys="field.fieldKey"
              :reviewData="reviewData"
            ></arb-review-status-icon>
            <arb-bulb-tooltips
              v-if="assist.tool.isNotEmpty(field.speechCraftCode)"
              :position="field.tooltipPosition"
              :speechCraftCode="field.speechCraftCode"
              :toolTipData="toolTipData"
            ></arb-bulb-tooltips>
            <arb-event-tooltips
              :className="'fad text-warning'"
              v-if="isShowElement(privileges, field.code, assist.dataType.PrivilegeType.EXECUTABLE)"
              :icon="field.icon"
              @click="triggerAmount(field.action)"
              :toolTipData="field.tooltip"
            ></arb-event-tooltips>
          </label>
        </v-flex>
        <v-flex class="p-v-0 p-h-0"
                :class="field.valueClass ? field.valueClass : field.isWholeRow ? 'lg9' : 'lg3'"
                :key="assist.tool.getRandomKey (index)"
                v-if="isDisplayField(field.fieldKey, field.loanType) && !field.blankRow && !field.divider"
        >
          <label class="field-value"
                 :class="field.class"
                 :title="assist.tool.fieldRender(dataSource.sectionData, field.template, field.format, getOptions(field.options), field.case, field, operator, currentLockedId)"
          >
            {{ assist.tool.fieldRender(dataSource.sectionData, field.template, field.format, getOptions(field.options), field.case, field, operator, currentLockedId) }}
          </label>
        </v-flex>
        <v-flex v-if="field.divider" :key="assist.tool.getRandomKey (index)" class="p-v-0 p-h-0" :class="field.class ? field.class : 'lg6'">
          <v-divider class="m-v-0"  :key="assist.tool.getRandomKey (index)"></v-divider>
        </v-flex>
        <v-flex v-if="field.divider && !field.class" :key="assist.tool.getRandomKey (index)" class="p-v-0 p-h-0" lg6></v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { Authentication, DataType, Tool } from '@/util'

const tool = new Tool()
export default {
  name: 'section-form',
  props: {
    sectionData: Object,
    reviewData: Object,
    layoutSetting: Object,
    loan: Object,
    privileges: {
      type: Array,
      default: () => []
    },
    currentLockedId: Number,
    operator: {
      type: Object,
      default: () => {}
    },
    toolTipData: String
  },
  data () {
    return {
      dataSource: {
        sectionData: {},
        reviewData: []
      },
      assist: {
        tool: tool,
        dataType: DataType
      }
    }
  },
  watch: {
    sectionData: {
      handler: function () {
        this.storeSectionData()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.storeSectionData()
    this.storeReviewData()
  },
  methods: {
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value) && Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    getOptions (options) {
      if (typeof (options) === 'string') {
        // eslint-disable-next-line no-eval
        return eval(options)
      } else {
        return options
      }
    },
    /* end of callback method //:~ */

    /* start of render method */
    isDisplayField (fieldKey, loanType) {
      if (this.assist.tool.isNotEmpty(loanType) && loanType.indexOf(this.loan.loanType) === -1) {
        return false
      }

      if (fieldKey !== 'firstDayOfWeek' && fieldKey !== 'firstDayOfMonth' && fieldKey !== 'secondDayOfMonth') {
        return true
      }

      const payrollFrequency = this.dataSource.sectionData.payrollFrequency
      return tool.displayByPayrollFrequency(fieldKey, payrollFrequency)
    },
    /* end of render method //:~ */

    /* start of operation method */
    storeSectionData () {
      const sectionData = this.sectionData
      this.dataSource.sectionData = sectionData
    },
    storeReviewData () {
      let sourceData = this.reviewData
      if (this.assist.tool.isEmpty(sourceData)) {
        sourceData = []
      }

      const targetData = []
      const reviewStatusData = {}

      if (sourceData.length > 0) {
        const sectionKey = this.layoutSetting.section.name

        for (const item of sourceData) {
          if (item.sectionKey === sectionKey) {
            reviewStatusData[item.fieldKey] = item.reviewStatus

            targetData.push(item)
          }
        }
      }

      this.dataSource.reviewData = targetData
    }
  }
}
</script>

<style lang="scss" scoped>
.section-form {
  font-size: 14px;
  .flex {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row {
    margin: auto !important;
  }
  .field-value {
    display: initial !important;
  }
}
</style>
